///<reference path="../../../typings/jsplumb/jquery.jsPlumb.d.ts"/>
///<reference path="../../../typings/jqueryui/jqueryui.d.ts"/>
///<reference path="../../../typings/lodash/lodash.d.ts"/>
///<reference path="processEditor-module.ts"/>
///<reference path="process.ts"/>
///<reference path="popoverService.ts"/>
///<reference path="scopeEditorController.ts"/>
///<reference path="conditionInfoService.ts"/>

module ProcessEditor {
    'use strict';

    /**
    * jsPlumb Connection drawing service
    */
    export class ConnectionDrawingService {
        constructor(public scopeId: string,
            public jsPlumbObj: jsPlumbInstance,
            private popoverService: PopoverService,
            private scopeConnectionEventHandler: IScopeConnectionEventHandler,
            private graphValidationService: GraphValidationService,
            private conditionInfoService: ConditionInfoService,
            private viewingOldProcessVersion: boolean) {
            this.bindConnectionEvents();
        }

        private bindConnectionEvents() {
            function getConnectionKey(info: IJsPlumbConnectionInfo): INodeConnectionKey {
                return {
                    sourceEndpointId: info.sourceEndpoint.getUuid(),
                    targetEndpointId: info.targetEndpoint.getUuid()
                };
            }
            function getPreviousConnectionKey(info: IJsPlumbMovedConnectionInfo): INodeConnectionKey {
                return {
                    sourceEndpointId: info.originalSourceEndpoint.getUuid(),
                    targetEndpointId: info.originalTargetEndpoint.getUuid()
                };
            }
            function getNewConnectionKey(info: IJsPlumbMovedConnectionInfo): INodeConnectionKey {
                return {
                    sourceEndpointId: info.newSourceEndpoint.getUuid(),
                    targetEndpointId: info.newTargetEndpoint.getUuid()
                };
            }

            this.jsPlumbObj.bind("connection", (info: IJsPlumbConnectionInfo, originalEvent: JQueryEventObject) => {
                if (originalEvent) {
                    // only trigger if actual event - we already know about the programmatic connections
                    this.scopeConnectionEventHandler.addNewConnection(getConnectionKey(info));
                    this.graphValidationService.validateGraphConnections();
                    this.graphValidationService.markProcessDirty();

                    if (info.connection.getParameter("type") === "decisionBranch") {
                        var overlay = info.connection.getOverlay("conditionOverlay");
                        var conditionInfo = this.conditionInfoService.fromConnectionEventInfo(info, overlay);
                        if (conditionInfo) {
                            this.scopeConnectionEventHandler.addDecisionCondition(conditionInfo);

                            if (overlay) {
                                let labelElement = angular.element(overlay.canvas);
                                this.bindDecisionPopover(conditionInfo, labelElement);

                                let isElseBranch = getEndpointTypeFromEndpointId(conditionInfo.sourceEndpointId) === EndpointType.else;
                                if (!isElseBranch) {
                                    // A new conditional connection has been made. Open the condition form popover.
                                    this.popoverService.openPopover(this.scopeId, labelElement);
                                }
                            }
                        }
                    }
                }
            });

            this.jsPlumbObj.bind("connectionDetached", (info: IJsPlumbConnectionInfo, originalEvent: JQueryEventObject) => {
                if (info.connection.getParameter("type") === "decisionBranch") {
                    var overlay = info.connection.getOverlay("conditionOverlay");
                    var conditionInfo = this.conditionInfoService.fromConnectionEventInfo(info, overlay);
                    this.scopeConnectionEventHandler.removeDecisionCondition(conditionInfo);
                }
                this.scopeConnectionEventHandler.removeConnection(getConnectionKey(info));
                this.graphValidationService.markProcessDirty();

                setTimeout(() => {
                    // Reason for timeout: JSPlumb triggers this event on 'mouseup' when a connection is being detached.
                    // At that very moment, the connection still exists (source is connected, target is hanging in mid-air).
                    // Wait for JSPlumb to actually remove the connection, or the source endpoint will falsely think it's connected and valid.
                    this.graphValidationService.validateGraphConnections();
                }, 50);
            });

            this.jsPlumbObj.bind("connectionMoved", (info: IJsPlumbMovedConnectionInfo, originalEvent: JQueryEventObject) => {
                if (info.connection.getParameter("type") === "decisionBranch") {
                    var overlay = info.connection.getOverlay("conditionOverlay");
                    var originalConditionInfo = this.conditionInfoService.fromEndpointIds(info.originalSourceEndpoint.getUuid(), info.originalTargetEndpoint.getUuid(), overlay);
                    var newConditionInfo = this.conditionInfoService.fromEndpointIds(info.newSourceEndpoint.getUuid(), info.newTargetEndpoint.getUuid(), overlay);
                    this.scopeConnectionEventHandler.updateDecisionCondition(originalConditionInfo, newConditionInfo);
                }
                this.scopeConnectionEventHandler.removeConnection(getPreviousConnectionKey(info));
                this.scopeConnectionEventHandler.addNewConnection(getNewConnectionKey(info));
            });

            this.jsPlumbObj.bind("connectionDrag", (connection) => {
                // When dragging a connection, the ball that you grabbed should be "duplicated" (one that's being dragged, and one where you grabbed it from.)
                // JSPlumb creates a clone of the ball you're dragging, and places it where you grabbed it from. But endpoints are transparent by default!
                // Wait for the duplication to finish, and make the new endpoint visible. Don't worry, this only gets fired once per dragging event (not every pixel).
                setTimeout(() => {
                    $(".process-endpoint._jsPlumb_dragging").addClass("process-endpoint-dragging");
                }, 0);
            });

            // selectEndpoints() will only return endpoints within the scope (root/foreach/error) of the TARGET endpoint.
            // info.sourceId is the nodeId of the SOURCE.
            // If the connection's source is found in the target scope, continue with the connection. If not, cancel by returning false.
            this.jsPlumbObj.bind("beforeDrop", (info) => {
                var inSameScope = false;
                var endpoints = this.jsPlumbObj.selectEndpoints().each((endpoint) => {
                    if (endpoint.elementId === info.sourceId) {
                        inSameScope = true;
                    }
                });

                return inSameScope;
            });

            // Class .process-endpoint-dragging is applied to all target endpoints while dragging.
            // This cannot be bound to the endpoint elements, because the mouse is not on the endpoint anymore after dragging.
            $("#process-editor").on("mouseup", () => {
                $(".process-endpoint").removeClass("process-endpoint-dragging");
            });
        }
        private dropOptions = {
            tolerance: "touch",
            hoverClass: "dropHover",
            activeClass: "dragActive"
        };
        private defaultColor = "#17add7";
        private lineWidth = 2;
        private grayedOutConnectionPaintStyle: PaintStyle = { fillStyle: "lightgray", strokeStyle: "lightgray", lineWidth: this.lineWidth }
        private endpointDecisionSourceParams: EndpointParams = {
            endpoint: "Dot",
            paintStyle: { fillStyle: this.defaultColor },
            cssClass: "process-endpoint",
            anchor: ["Right", "Top"],
            isSource: true,
            maxConnections: 100,
            connectorStyle: { strokeStyle: this.defaultColor, lineWidth: this.lineWidth },
            connector: ["Flowchart", { gap: 0, cornerRadius: 5, alwaysRespectStubs: false }],
            connectorOverlays: [["Label", { label: "", id: "conditionOverlay", cssClass: "condition-label" }]],
            isTarget: false,
            dropOptions: this.dropOptions,
            parameters: {
                type: "decisionBranch"
            }
        };
        private endpointDecisionElseSourceParams: EndpointParams = {
            endpoint: "Dot",
            paintStyle: { fillStyle: this.defaultColor },
            cssClass: "process-endpoint",
            anchor: ["Bottom"],
            isSource: true,
            maxConnections: 1,
            connectorStyle: { strokeStyle: this.defaultColor, lineWidth: this.lineWidth },
            connector: ["Flowchart", { gap: 0, cornerRadius: 5, alwaysRespectStubs: false }],
            connectorOverlays: [["Label", { label: "else", id: "conditionOverlay", cssClass: "condition-label" }]],
            isTarget: false,
            dropOptions: this.dropOptions,
            parameters: {
                type: "decisionBranch"
            }
        };
        private endpointSourceParams: EndpointParams = {
            endpoint: "Dot",
            paintStyle: { fillStyle: this.defaultColor },
            cssClass: "process-endpoint",
            anchor: ["Right"],
            isSource: true,
            maxConnections: 100,
            connectorStyle: { strokeStyle: this.defaultColor, lineWidth: this.lineWidth },
            connector: ["Flowchart", { gap: 0, cornerRadius: 5, alwaysRespectStubs: false }],
            isTarget: false,
            dropOptions: this.dropOptions
        };
        private endpointStartParams: EndpointParams = {
            endpoint: "Dot",
            paintStyle: { fillStyle: "green" },
            cssClass: "process-endpoint",
            anchor: [0, 0, 1, 0, 0, 100],
            isSource: true,
            maxConnections: 100,
            connectorStyle: { strokeStyle: this.defaultColor, lineWidth: this.lineWidth },
            connector: ["Flowchart", { gap: 0, cornerRadius: 5, alwaysRespectStubs: false }],
            isTarget: false,
            dropOptions: this.dropOptions
        };
        private endpointTargetParams: EndpointParams = {
            endpoint: "Dot",
            paintStyle: {
                strokeStyle: this.defaultColor,
                fillStyle: "white",
                lineWidth: 2
            },
            cssClass: "process-endpoint",
            anchor: "Left",
            isSource: false,
            maxConnections: 100,
            connectorStyle: { strokeStyle: this.defaultColor, lineWidth: this.lineWidth },
            connector: "Straight",
            isTarget: true,
            dropOptions: this.dropOptions
        };

        public updateLabels(nodeId: string, condition: ConditionBranch) {
            var connections = this.jsPlumbObj.getConnections({ source: nodeId });
            _.each(connections, connection => {
                var overlay = connection.getOverlay("conditionOverlay");
                if (overlay) {
                    // source is always the first one, target the second one
                    var sourceEndpoint = connection.endpoints[0];
                    var targetEndpoint = connection.endpoints[1];

                    if (sourceEndpoint.getUuid() === condition.sourceEndpointId &&
                        targetEndpoint.getUuid() === condition.targetEndpointId) {
                        this.updateLabel(overlay, condition.name, condition.conditionId);
                    }
                }
            });
        }

        private updateLabel(overlay: LabelOverlay, newText: string, conditionId: string) {
            overlay.setLabel(newText || "");
        }

        public drawEndpoints(nodes: IEndpointDetails[], graphEditDisabled: boolean) {
            _.each(nodes, node => {
                this.initializeEndpoints(node, graphEditDisabled);
            });
        }

        public drawConnections(connections: NodeConnection[], nodes: Node[], graphEditDisabled: boolean, highlightExecutedConnections: boolean) {
            class NodeConnectionWithExecutionData extends NodeConnection {
                public executed: boolean;
            }
            /** Helper method for enriching the connection data with execution status */
            function getConnectionsWithExecutionStatus(nodeHash: NodeHash): NodeConnectionWithExecutionData[] {
                function nodeExecuted(connection: NodeConnection, nodeId: string): boolean {
                    const node = <{ executionData?: ProcessInstanceStep }>nodeHash[nodeId];
                    // start nodes currently do not get logging details
                    return node instanceof StartNode || !!node.executionData;
                }

                var connectionsWithExecutedStatus = connections.map(c => {
                    var conn = new NodeConnectionWithExecutionData(c);
                    conn.executed = nodeExecuted(c, c.targetNodeId) && nodeExecuted(c, c.sourceNodeId);
                    return conn;
                });

                // go through the decision node branches as well, setting states
                var decisionNodes = <DecisionNode[]>_.filter(nodes, n => n instanceof DecisionNode);
                for (let decisionNode of decisionNodes) {
                    let executedConditionId = "<unknown>";
                    if (decisionNode instanceof DecisionNodeWithExecutionData && decisionNode.executionData) {
                        executedConditionId = decisionNode.executionData.result;
                    }
                    for (var branch of decisionNode.conditionBranches) {
                        var branchConn = _.find(connectionsWithExecutedStatus, c => c.sourceEndpointId === branch.sourceEndpointId && c.targetEndpointId === branch.targetEndpointId);
                        if (branchConn) {
                            if (executedConditionId === "else" && branch.isElseBranch) {
                                branchConn.executed = true;
                            } else if (executedConditionId === branch.conditionId) {
                                branchConn.executed = true;
                            } else {
                                branchConn.executed = false;
                            }
                        }
                    }
                }

                // sort the connections so executed connections are drawn last, i.e on top.
                return _.sortBy(connectionsWithExecutedStatus, c => c.executed === true);
            }

            let nodeHash = new NodeHash(nodes);
            let connectionsToDraw = highlightExecutedConnections ? getConnectionsWithExecutionStatus(nodeHash) : connections;

            _.each(connectionsToDraw, c => {
                let connection = this.jsPlumbObj.connect({ uuids: [c.sourceEndpointId, c.targetEndpointId], detachable: !graphEditDisabled });

                if (!connection) {
                    console.error(`Could not draw connection from ${c.sourceEndpointId} to ${c.targetEndpointId}`);
                    return;
                }
                if (highlightExecutedConnections && c instanceof NodeConnectionWithExecutionData && !c.executed) {
                    connection.setPaintStyle(this.grayedOutConnectionPaintStyle);
                }

                // Received information about connections and conditions from server. Create conditionInfo and do condition bindings.
                let conditionOverlay = connection.getOverlay("conditionOverlay");
                if (conditionOverlay) {
                    const decisionNode = nodeHash[c.sourceNodeId];
                    if (decisionNode instanceof DecisionNode) {
                        const condition = getConditionFromDecisionNode(decisionNode, c);

                        if (condition) {
                            const conditionInfo = this.conditionInfoService.fromConditionBranch(condition, conditionOverlay);
                            this.updateLabels(decisionNode.nodeId, condition);
                            this.bindDecisionPopover(conditionInfo, angular.element(conditionOverlay.canvas));
                        }
                    }
                }
            });
        }

        /** Repaints all endpoints and connections. Helpful if the elements have been resized or moved */
        public redrawEverything() {
            this.jsPlumbObj.repaintEverything();
        }

        /** Resets all connections and endpoints. Useful if you want to reuse the same canvas with different endpoints */
        public reset() {
            this.jsPlumbObj.reset();
        }

        public getNewNodePosition(nodes: Node[]) {
            if (_.isEmpty(nodes)) {
                return new Position({ top: 30, left: 50 });
            }
            var furthestRightNode = _.maxBy(nodes, n => n.position.left);
            var newNodeLeftPosition = furthestRightNode.position.left + $("#" + furthestRightNode.nodeId).outerWidth() + 50;
            return new Position({ top: furthestRightNode.position.top, left: newNodeLeftPosition });
        }

        public deleteEndpointElement(endpointElementId: string) {
            // also hide all popovers so they do not get left behind TODO: should the popovers just be deleted?
            this.popoverService.hidePopovers(this.scopeId);

            this.jsPlumbObj.removeAllEndpoints(endpointElementId);
        }

        private getEndpointParams(graphEditDisabled: boolean, endpointParams: EndpointParams) {
            return (graphEditDisabled || this.viewingOldProcessVersion) ? this.disableGraphEdit(endpointParams) : endpointParams;
        }

        private disableGraphEdit(params: EndpointParams) {
            var newParams = _.clone(params);

            newParams.isSourceEnabled = false;
            newParams.isTargetEnabled = false;
            newParams.isSource = false;
            newParams.endpoint = "Blank";

            return newParams;
        }

        private initializeEndpoints(endpointDetails: IEndpointDetails, graphEditDisabled: boolean) {
            var element = $("#" + endpointDetails.nodeId);

            if (endpointDetails.targetEndpointId) {
                var targetParams = this.getEndpointParams(graphEditDisabled, this.endpointTargetParams);
                var targetEndpoint = this.jsPlumbObj.addEndpoint(element, { uuid: endpointDetails.targetEndpointId }, targetParams);
                this.bindEndpointEvents(targetEndpoint);
            }
            if (endpointDetails.sourceEndpointDetails) {
                // currently only decision nodes have more than one source endpoint, so use that to identify them
                const isDecisionEndpoint = endpointDetails.sourceEndpointDetails.length > 1;
                _.each(endpointDetails.sourceEndpointDetails, sourceEndpoint => {
                    if (isDecisionEndpoint) {
                        const endpointType = getEndpointTypeFromEndpointId(sourceEndpoint.endpointId);
                        let decisionBranchParams: EndpointParams;
                        if (endpointType === EndpointType.source) {
                            decisionBranchParams = this.getEndpointParams(graphEditDisabled, this.endpointDecisionSourceParams);
                        } else if (endpointType === EndpointType.else) {
                            decisionBranchParams = this.getEndpointParams(graphEditDisabled, this.endpointDecisionElseSourceParams);
                        }
                        var decisionEndpoint = this.jsPlumbObj.addEndpoint(element, {
                            uuid: sourceEndpoint.endpointId
                        }, decisionBranchParams);
                        this.bindEndpointEvents(decisionEndpoint);
                    } else {
                        var defaultSourceParams = this.getEndpointParams(graphEditDisabled, this.endpointSourceParams);
                        var defaultSourceEndpoint = this.jsPlumbObj.addEndpoint(element, { uuid: sourceEndpoint.endpointId }, defaultSourceParams);
                        this.bindEndpointEvents(defaultSourceEndpoint);
                    }
                });
            }

            if (!graphEditDisabled && !this.viewingOldProcessVersion) {
                this.jsPlumbObj.draggable(element, {
                    containment: element.parents(".process-node-container").first(),
                    start: (event) => {
                        this.popoverService.hidePopovers(this.scopeId);
                        element.data("hasBeenDragged", true);
                    },
                    stop: (event, ui) => {
                        this.scopeConnectionEventHandler.moveEndpoint(
                            $(event.target).attr('id'),
                            new ProcessEditor.Position({ top: ui.position.top, left: ui.position.left }));

                        // This flag gets set to false at the end of the 'click' event for draggable elements.
                        // Still, manually set it to false after a small delay, because things CAN go wrong with the click (ie. mouse is moving too fast)
                        setTimeout(() => { element.data("hasBeenDragged", false); }, 100);

                        this.graphValidationService.markProcessDirty();
                    }
                });
            }
        }

        private bindDecisionPopover(conditionInfo: ConditionInfo, labelElement: JQuery) {
            this.popoverService.setupPopover(labelElement, conditionInfo.formId, conditionInfo.formContainerId, {
                onOpen() {
                    // broadcast event so e.g. CodeMirror editors are initialized
                    angular.element(conditionInfo.formContainerId).scope().$broadcast("show.editor.frends");
                }, onClose() { }
            });
            labelElement.off("click").on("click", (event: JQueryEventObject) => {
                this.popoverService.openPopover(this.scopeId, $(event.target));
            });
        }

        private bindEndpointEvents = (endpoint) => {
            // Show target endpoints within the same scope when dragging a connection
            endpoint.bind("mousedown", () => {
                this.jsPlumbObj.selectEndpoints().each((ep) => {
                    if (ep.isTarget) {
                        angular.element(ep.canvas).addClass("process-endpoint-dragging");
                    }
                });
            });

            // Show endpoint when hovering over its node. This only handles hovering over the NODE box.
            // Hovering over endpoint elements is handled by CSS : hover and : active
            $(endpoint.element).hover(
                () => { angular.element(endpoint.canvas).addClass("process-endpoint-hover"); },
                () => { angular.element(endpoint.canvas).removeClass("process-endpoint-hover"); });
        };
    }

    export interface IEndpointDetails {
        nodeId: string;
        targetEndpointId?: string;
        sourceEndpointDetails?: SourceEndpointDetails[];
        startEndpointId?: string;
    }

    export interface IJsPlumbConnectionInfo {
        connection: Connection;
        sourceId: string;
        targetId: string;
        source: Element;
        target: Element;
        sourceEndpoint: Endpoint;
        targetEndpoint: Endpoint;
    }

    export interface IJsPlumbMovedConnectionInfo {
        index: Number;
        connection: any;
        originalSourceId: string;
        newSourceId: string;
        originalTargetId: string;
        newTargetId: string;
        originalSourceEndpoint: Endpoint;
        newSourceEndpoint: Endpoint;
        originalTargetEndpoint: Endpoint;
        newTargetEndpoint: Endpoint;
    }

    export class ConnectionDrawingServiceFactory {
        static $inject = ["jsPlumb", "PopoverService", "GraphValidationService", "ConditionInfoService", "graphEditDisabled", "ProcessService"];
        constructor(private globalJsPlumbObj: jsPlumbInstance,
            private popoverService: PopoverService,
            private graphValidationService: GraphValidationService,
            private conditionInfoService: ConditionInfoService,
            public graphEditDisabled: boolean,
            private processService: ProcessService) {
        }

        public getConnectionDrawingServiceInstanceFor(containerId: string, scopeConnectionEventHandler: IScopeConnectionEventHandler): ConnectionDrawingService {
            var localJsPlumbObj = this.globalJsPlumbObj.getInstance({
                container: $("#" + containerId),
                ConnectionOverlays: [["Arrow", { location: 1, width: 14, length: 7 }]]
            });

            return new ConnectionDrawingService(
                containerId,
                localJsPlumbObj,
                this.popoverService,
                scopeConnectionEventHandler,
                this.graphValidationService,
                this.conditionInfoService,
                this.processService.currentProcess.isNotLatestVersion);
        }
    }
    app.service("ConnectionDrawingServiceFactory", ConnectionDrawingServiceFactory);
}
